module.exports = __webpack_public_path__ + "static/img/2.dd01814.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/2.png
// module id = 6w3v
// module chunks = 0